import { Divider, Form, Input, Modal, Space, Typography } from 'antd'
import { addTicketsFx } from 'src/pages/goldenMay2026/tickets/model'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const AddTicketsModal = ({ isVisible, onClose }: Props) => {
  const [form] = Form.useForm()
  const { Item } = Form
  const { Text } = Typography

  const handleSubmit = async () => {
    try {
      const { ticketID, userID } = await form.validateFields()
      await addTicketsFx({ body: { ticketID, userID } })
      form.resetFields()
      onClose()
    } catch (error) {
      console.log('Validation failed:', error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Add tickets</div>}
      open={isVisible}
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      destroyOnHidden
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Submit"
    >
      <Divider />
      <Form layout="vertical" onFinish={handleSubmit} form={form}>
        <Space>
          <Item
            label={
              <Text style={{ fontSize: 16 }} strong>
                ticketID
              </Text>
            }
            name="ticketID"
            required={false}
            rules={[
              {
                required: true,
                message: 'Required field',
              },
            ]}
          >
            <Input placeholder="ticketID" style={{ width: 270 }} />
          </Item>
          <Item
            label={
              <Text style={{ fontSize: 16 }} strong>
                userID
              </Text>
            }
            name="userID"
            required={false}
            rules={[
              {
                required: true,
                message: 'Required field',
              },
            ]}
          >
            <Input placeholder="userID" style={{ width: 270 }} />
          </Item>
        </Space>
      </Form>
    </Modal>
  )
}
